import {Heading} from 'platform/foundation';

import i18n from '@dms/i18n';

import {EngineInfoGroup} from '../../kit/groups/EngineInfoGroup';
import {isTrailerOrSemitrailer} from '../../kit/utils/isTrailerOrSemitrailer';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function EngineDetailsSubSection() {
  return (
    <VFKit.SubSection data-testid="engine-details">
      <VFKit.ShowWhen
        name="type"
        condition={(type) => !isTrailerOrSemitrailer(type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR')}
      >
        <Heading size={4}>{i18n.t('entity.vehicle.labels.engine')}</Heading>
        <VFKit.Group data-testid="engine-info" columns={[1, 2, 4]}>
          <EngineInfoGroup />
        </VFKit.Group>
      </VFKit.ShowWhen>
    </VFKit.SubSection>
  );
}
